<template>
  <div style="border: 1px solid #ccc">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor style="height: 500px; overflow-y: hidden" v-model="item.Text" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" />
  </div>
</template>
<script>
import PatientCenter from "../../api/PatientCenter";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
export default {
  data() {
    return {
      str: "<p>123121231<strong>2312</strong></p>",
      problem: [],
      editor: null,
      html: "",
      toolbarConfig: {},
      editorConfig: {
        placeholder: "请输入内容...",
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            customUpload: this.update,
          },
          // 继续其他菜单配置...
        },
      },
      mode: "simple", // or 'simple' 'default'
    };
  },
  components: {
    Editor,
    Toolbar,
  },
  props: ["item"],
  methods: {
    update(file, insertFn) {
      // file 即选中的文件
      let name = file.name.split(".")[0];
      let suffix = file.type.split("/")[1];
      name = name + "." + suffix;
      let F = new FormData();
      F.append("File", file);
      PatientCenter.addPic(F).then((r) => {
        insertFn(r.data.Data, file.name);
      });
    },
    // type() {
    //   const Dialect = "HDH";
    //   PatientCenter.BaseDataBigData(Dialect).then((res) => {
    //     if (res.data.Status == 1) {
    //       this.problem = res.data.Data;
    //     } else {
    //       alert(res.data.Message);
    //     }
    //   });
    // },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
  },
  mounted() {
    // console.log(this.item);
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.drawer_form {
  background: #f7f7f7;
  padding: 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
}
</style>